<template>
  <v-dialog v-model="dialogVisible" max-width="620px">
    <v-card>
      <v-card-title class="text-h6">Edit Properties</v-card-title>
      <v-card-text>
        <div v-for="(options, field) in dropdownOptions" :key="field" class="d-flex align-center mb-4">
          <label class="me-4" style="min-width: 164px">{{ field }}</label>
          <v-select
            v-model="formData[field]"
            :items="['', ...options]"
            variant="outlined"
            density="compact"
            hide-details
          />
        </div>
        <v-textarea
          v-if="errors.length"
          v-model="errorText"
          readonly
          variant="outlined"
          density="compact"
          rows="3"
          class="mt-4"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="handleCancel">Cancel</v-btn>
        <v-btn text @click="handleSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const DROPDOWN_OPTIONS = {
  thisUrl: [
    '/compareStt/compare/prompt',
    '/compareStt/compare/record',
    '/compareStt/compare/gather_yesno',
    '/compareStt/compare/wait-for-agent',
    '/compareStt/compare/end-call-prompt'
  ],
  targetId: [
    'IdOne',
    'IdTwo',
    'IdThree',
    'IdFour',
    'IdFive',
    'IdSix',
    'IdSeven',
    'IdEight',
    'IdNine',
    'IdTen'
  ],
  noBranchTarget: [
    'IdOne',
    'IdTwo',
    'IdThree',
    'IdFour',
    'IdFive',
    'IdSix',
    'IdSeven',
    'IdEight',
    'IdNine',
    'IdTen'
  ],
  yesBranchTarget: [
    'IdOne',
    'IdTwo',
    'IdThree',
    'IdFour',
    'IdFive',
    'IdSix',
    'IdSeven',
    'IdEight',
    'IdNine',
    'IdTen'
  ],
  skipToTarget: [
    'IdOne',
    'IdTwo',
    'IdThree',
    'IdFour',
    'IdFive',
    'IdSix',
    'IdSeven',
    'IdEight',
    'IdNine',
    'IdTen'
  ],
  name: [
    'hasBookingNumber',
    'intro',
    'detaineePhone',
    'detainee',
    'whereJailed',
    'bailAmount',
    'address',
    'knowPhoneNumber',
    'outsiderQuery',
    'outsiderName',
    'outsiderPhoneNumber',
    'doTheyKnow',
    'canWeContact',
    'hearingDate',
    'hearingTime',
    'waitForAgent',
    'wrapUp',
    'end-call'
  ],
  speechResultProcess: [
    'promptProcess',
    'digitSequenceRaw',
    'digitSequence',
    'name',
    'nameAndDigitSequence',
    'findFacility',
    'bailAmount',
    'narrativeProcess',
    'yesNo',
    'yesNoOrNarrative'
  ],
  verify: ['true'],
  showAudio: ['true'],
  language: ['en-US', 'es-MX', 'ru-RU']
};

export default {
  name: 'JailCallMenuEditorPropertiesDialog',
  props: {
    modelValue: Boolean,
    item: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue', 'save'],
  data() {
    return {
      dropdownOptions: DROPDOWN_OPTIONS,
      formData: {},
      errors: []
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
    errorText: {
      get() {
        return this.errors.join('\n');
      }
    }
  },
  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.initializeDialog();
      }
    }
  },
  methods: {
    initializeDialog() {
      this.errors = [];
      this.formData = {};
      
      Object.keys(this.item).forEach(key => {
        if (key === 'prompt' || key === 'id') return;
        
        if (!this.dropdownOptions[key]) {
          this.errors.push(`Property ${key} is in the target object but is not reflected in the UI.`);
          return;
        }

        const value = this.item[key];
        if (value && !this.dropdownOptions[key].includes(value)) {
          this.errors.push(`Property value ${value} is in the target object but does not exist in the dropdown ${key}.`);
        }
        
        this.formData[key] = value || '';
      });

      Object.keys(this.dropdownOptions).forEach(key => {
        if (!(key in this.formData)) {
          this.formData[key] = '';
        }
      });
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleSave() {
      const updates = {};
      Object.entries(this.formData).forEach(([key, value]) => {
        if (value) {
          updates[key] = value;
        }
      });
      this.$emit('save', updates);
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>
.v-select {
  width: 90%;
}
</style>
